/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskPaginatedForm5500Response
 */
export interface ExecRiskPaginatedForm5500Response {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm5500Response
     */
    total?: number;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ExecRiskPaginatedForm5500Response
     */
    results: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedForm5500Response
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm5500Response
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedForm5500Response
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedForm5500Response interface.
 */
export function instanceOfExecRiskPaginatedForm5500Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedForm5500ResponseFromJSON(json: any): ExecRiskPaginatedForm5500Response {
    return ExecRiskPaginatedForm5500ResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedForm5500ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedForm5500Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': json['results'],
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedForm5500ResponseToJSON(value?: ExecRiskPaginatedForm5500Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': value.results,
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

